module.exports = __webpack_public_path__ + "static/img/08.58d26c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic/08.jpg
// module id = MSeG
// module chunks = 1